import React from 'react'

export default function WorkProcess() {
  return (
    <section id="work-process" className="work-process section">
       
        <div className="container section-title" data-aos="fade-up">
          <h2>Our Consulting Process</h2>
          <div>
            <span>Check Our</span>
            <span className="description-title"> Consulting Process</span>
          </div>
        </div>
      

        <div className="container" data-aos="fade-up" data-aos-delay="100">
          <div className="row">
            <div className="col-lg-6" data-aos="fade-up" data-aos-delay="200">
              <div className="steps-content">
                <h2>Our Proven Consulting Process</h2>
                <p className="lead">
                  We follow a structured and transparent approach to deliver safe, 
                  reliable, and cost-effective electrical and automation solutions 
                  for industries, businesses, and residential projects.
                </p>
                <p>
                  From requirement analysis and detailed engineering to installation, 
                  testing, and client training — every step is handled by our 
                  experienced team of engineers and technicians to ensure your 
                  project runs smoothly and meets international standards.
                </p>

                <div className="steps-cta">
                  <a href="#consultation" className="btn btn-primary"
                    >Start Your Project
                  </a>
                  <a href="#about" className="btn btn-outline">Learn More</a>
                </div>
              </div>
            </div>

            <div className="col-lg-6" data-aos="zoom-out" data-aos-delay="300">
              <div className="steps-list">
                <div className="step-item">
                  <div className="step-number">01</div>
                  <div className="step-content">
                    <h3>Requirement Analysis</h3>
                    <p>
                      Site survey & load calculation. Client consultation to 
                      understand goals. Selection of optimal technical solution.
                    </p>
                  </div>
                </div>

                <div className="step-item">
                  <div className="step-number">02</div>
                  <div className="step-content">
                    <h3>Design & Engineering</h3>
                    <p>
                      Electrical layout & single line diagram (SLD). Product 
                      selection (transformer, switchgear, etc.). Compliance 
                      with BSTI, IEC, and safety codes.
                    </p>
                  </div>
                </div>

                <div className="step-item">
                  <div className="step-number">03</div>
                  <div className="step-content">
                    <h3>Procurement & Logistics</h3>
                    <p>
                      Sourcing from trusted suppliers and manufacturers. 
                      Quality inspection of incoming equipment. Timely 
                      delivery to site.
                    </p>
                  </div>
                </div>

                <div className="step-item">
                  <div className="step-number">04</div>
                  <div className="step-content">
                    <h3>Installation & Testing</h3>
                    <p>
                      Installation by certified electricians and engineers. 
                      Testing and commissioning as per standards. Safety 
                      checks and insulation tests.
                    </p>
                  </div>
                </div>

                <div className="step-item">
                  <div className="step-number">05</div>
                  <div className="step-content">
                    <h3>Handover & Training</h3>
                    <p>
                      Detailed handover report and documentation. On-site 
                      operator training for the client. Warranty activation 
                      and AMC (if applicable).
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  )
}
